export default __webpack_public_path__ + "static/media/Frame-12.d626d2b9.png";